import { createReducer, on } from "@ngrx/store";

import * as systemTimeActions from "../store/system-time.actions";

export interface SystemTimeState {
  systemTime: Date;
  isTimeTravelOn: boolean;
  authorized: boolean;
}

const initialState: SystemTimeState = {
  systemTime: new Date(),
  isTimeTravelOn: false,
  authorized: false,
};

export const SYSTEM_TIME_REDUCER = createReducer(
  initialState,
  on(systemTimeActions.SET_SYSTEM_TIME, (state, action): SystemTimeState => {
    return {
      ...state,
      systemTime: action.systemTime,
    };
  }),
  on(
    systemTimeActions.SET_TIME_TRAVEL_IS_ACTIVE,
    (state, action): SystemTimeState => {
      return {
        ...state,
        isTimeTravelOn: action.isTimeTravelOn,
      };
    }
  ),
  on(
    systemTimeActions.SET_TIME_TRAVEL_AUTHORIZED,
    (state, action): SystemTimeState => {
      return {
        ...state,
        authorized: action.authorized,
      };
    }
  )
);
